// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'face-happy-solid';

export const Component = () => (
  <path
    fillRule='evenodd'
    d='M20.63 4.37C18.386 2.122 15.69 1 12.5 1 9.31 1 6.615 2.123 4.37 4.37 2.122 6.614 1 9.31 1 12.5c0 3.19 1.123 5.885 3.37 8.13C6.614 22.878 9.31 24 12.5 24c3.19 0 5.885-1.123 8.13-3.37C22.878 18.386 24 15.69 24 12.5c0-3.19-1.123-5.885-3.37-8.13ZM19 14v1.5s-.944 4-6.533 4c-5.59 0-6.467-4-6.467-4V14h13Zm-3-7a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1ZM9 7a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1Z'
  />
);

export const viewBox = '0 0 25 25';
